import { ImageDataLike } from 'gatsby-plugin-image';

const ChdTvVideos = {
  Episode: { contentType: 'Episode', DropdownLabel: 'Weekly Shows' },
  EventVideo: { contentType: 'Event', DropdownLabel: 'Events' },
  Video: { contentType: 'Video', DropdownLabel: 'Videos' },
};

const ChdTvIndexes = [{ indexName: process.env.GATSBY_SEARCH_CHDTV_INDEX_NAME, indexLabel: 'Relevance' }, { indexName: `${process.env.GATSBY_SEARCH_CHDTV_INDEX_NAME}_oldest`, indexLabel: 'Oldest' }, { indexName: `${process.env.GATSBY_SEARCH_CHDTV_INDEX_NAME}_latest`, indexLabel: 'Latest' }];

type Episode =
  {
    id: string,
    objectID: string,
    locale: string,
    videoTitle: string,
    videoDescription: string,
    publishedDate: string,
    videoYear: string,
    videoSlug: string,
    episodeNumber: string,
    parentTitle?: string,
    parentDescription?: string,
    contentType: string,
    videoThumbnail?:ImageDataLike | string,
    categories?: string[],
    tags?: string[],
  }
  type EventVideo =
  {
    id: string,
    objectID: string,
    locale: string,
    videoTitle: string,
    videoDescription: string,
    publishedDate: string,
    videoYear: string,
    videoSlug: string,
    eventTitle?: string,
    eventDescription?: string,
    contentType: string,
    videoThumbnail?:ImageDataLike | string,
    categories?: string[],
    tags?: string[],
  }

  type Video =
  {
    objectID: string,
    locale: string,
    videoTitle: string,
    videoDescription: string,
    publishedDate: string,
    videoYear: string,
    videoSlug: string,
    videoThumbnail?:ImageDataLike | string,
    contentType: string,
    categories?: string[],
    tags?: string[],
  }
export {
  ChdTvIndexes,
  ChdTvVideos,
  Episode,
  EventVideo,
  Video,
};
